/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */

import { useListCampsiteQuery } from '@/__generated__/public-graphql';

export default async (idList: string[]) => {
  const result = await useListCampsiteQuery.fetcher({
    where: {
      id: {
        _in: idList,
      },
    },
  })();
  // 受け取ったidListの順番を保持したまま、campsiteを返す
  return result.campsite.sort((a, b) => {
    const aIndex = idList.indexOf(a.id);
    const bIndex = idList.indexOf(b.id);
    return aIndex - bIndex;
  });
};
